import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import * as moment from 'moment';
import { LanguageService } from '../../services/language.service';
import { DxDropDownBoxComponent } from "devextreme-angular";

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.css']
})
export class DateSelectorComponent implements OnInit, AfterViewInit {

  tabsDateRange: any[] = [];
  @Input() tabsDateRangeSelectedIndex: number = 0;
  @Input()
  set setTabsDateRangeSelectedIndexInput(selIndx: number) {
    this.tabsDateRangeSelectedIndex = selIndx;
    this.setTabsDateRangeSelectedIndex();
  }
  @Input() showDay: boolean = true;
  @Input() showWeek: boolean = true;
  @Input() showMonth: boolean = true;
  @Input() showYear: boolean = false;
  @Input() showInterval: boolean = false;
  @Input() showDateTabs: boolean = true;
  @Input() maxDate: any = moment(new Date(8640000000000000));
  @Input() hasTodayButton = true;
  @Input() showSearchButton = true;
  @Input() emitChangeAfterInit = false;
  @Input() baseSizeCalendar = 320;

  private _selectedDate: any = moment();
  @Input() currentDate: any = moment();

  disableSelector: boolean = false;
  dateFrom: any = moment();
  dateTo: any = moment();
  text: string;
  minZoomLevel: any = "decade";
  maxZoomLevel: any = "month";
  zoomLevel: any = "month";
  intervalSelected: boolean = false;
  @Output() changeDate = new EventEmitter<any>();
  @Output() rangeSelectedIndexChanged = new EventEmitter<number>();
  todayText = this.languageService.LNG("Label.Today");
  searchText = this.languageService.LNG("Label.Search");

  constructor(private languageService: LanguageService) { }

  ngOnInit() {
    this.tabsDateRange.push({ id: 0, text: this.languageService.LNG("Label.Day"), visible: this.showDay });
    this.tabsDateRange.push({ id: 1, text: this.languageService.LNG("Label.Week"), visible: this.showWeek });
    this.tabsDateRange.push({ id: 2, text: this.languageService.LNG("Label.Month"), visible: this.showMonth });
    this.tabsDateRange.push({ id: 3, text: this.languageService.LNG("Label.Year"), visible: this.showYear });
    this.tabsDateRange.push({ id: 4, text: this.languageService.LNG("Label.Custom"), visible: this.showInterval });
    this.setDateText();
  }

  ngAfterViewInit() {
    if (this.emitChangeAfterInit) { setTimeout(() => this.setSelectedDate(), 0); }
  }

  tabs_dateRange_onSelectionChanged(args: any) {

    this.tabsDateRangeSelectedIndex = args.addedItems[0].id;
    if (this.tabsDateRangeSelectedIndex === 4) {
      this.intervalSelected = true;
    }
    else {
      this.intervalSelected = false;
    }
    this.rangeSelectedIndexChanged.emit(this.tabsDateRangeSelectedIndex);
    this.setTabsDateRangeSelectedIndex();
    this.setSelectedDate();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
  }

  setSelectedDate() {
    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this.dateFrom = this._selectedDate;
        this.dateTo = this._selectedDate;
        break;
      case 1:
        this.dateFrom = moment(this._selectedDate).startOf('isoWeek');
        this.dateTo = moment(this._selectedDate).endOf('isoWeek');
        break;
      case 2:
        this.dateFrom = moment(this._selectedDate).startOf('month');
        this.dateTo = moment(this._selectedDate).endOf('month');
        break;
      case 3:
        this.dateFrom = moment(this._selectedDate).startOf('year');
        this.dateTo = moment(this._selectedDate).endOf('year');
        break;
      default:
    }

    if (this.dateTo > this.maxDate) { this.dateTo = this.maxDate; }
  }

  prev_Click() {
    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this._selectedDate = moment(this._selectedDate).subtract(1, 'day');
        this.dateFrom = this._selectedDate;
        this.dateTo = this._selectedDate;
        break;
      case 1:
      this._selectedDate = moment(this._selectedDate).subtract(1, 'week');
        this.dateFrom = moment(this._selectedDate).startOf('isoWeek');
        this.dateTo = moment(this._selectedDate).endOf('isoWeek');
        break;
      case 2:
        this._selectedDate = moment(this._selectedDate).subtract(1, 'month');
        this.dateFrom = moment(this._selectedDate).startOf('month');
        this.dateTo = moment(this._selectedDate).endOf('month');
        break;
      case 3:
        this._selectedDate = moment(this._selectedDate).subtract(1, 'year');
        this.dateFrom = moment(this._selectedDate).startOf('year');
        this.dateTo = moment(this._selectedDate).endOf('year');
        break;
      default:
    }

    this.setDateText();
    this.currentDate = this.dateFrom;
  }

  next_Click() {
    if (this._selectedDate >= this.maxDate) { return; }

    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this._selectedDate = moment(this._selectedDate).add(1, 'day');
        this.dateFrom = this._selectedDate;
        this.dateTo = this._selectedDate;
        break;
      case 1:
        this._selectedDate = moment(this._selectedDate).add(1, 'week');
        this.dateFrom = moment(this._selectedDate).startOf('isoWeek');
        this.dateTo = moment(this._selectedDate).endOf('isoWeek');
        break;
      case 2:
        this._selectedDate = moment(this._selectedDate).add(1, 'months');
        this.dateFrom = moment(this._selectedDate).startOf('month');
        this.dateTo = moment(this._selectedDate).endOf('month');
        break;
      case 3:
        this._selectedDate = moment(this._selectedDate).add(1, 'year');
        this.dateFrom = moment(this._selectedDate).startOf('year');
        this.dateTo = moment(this._selectedDate).endOf('year');
        break;
      default:
    }

    this.setDateText();
    this.currentDate = this.dateFrom;
  }

  today_Click() {
    this._selectedDate = moment();
    this.setSelectedDate();
    this.setDateText();
    this.currentDate = this.dateFrom;
  }

  search_Click() {
    this.changeDate.emit({
      FromDate: moment(this.dateFrom),
      ToDate: moment(this.dateTo)
    });
  }

  dateChanged(e: any, calendarDropdown: DxDropDownBoxComponent) {
    this._selectedDate = moment(e.value);

    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this.dateFrom = this._selectedDate;
        this.dateTo = this._selectedDate;
        break;
      case 1:
        this.dateFrom = moment(this._selectedDate).startOf('isoWeek');
        this.dateTo = moment(this._selectedDate).endOf('isoWeek');
        break;
      case 2:
        this.dateFrom = moment(this._selectedDate).startOf('month');
        this.dateTo = moment(this._selectedDate).endOf('month');
        break;
      case 3:
        this.dateFrom = moment(this._selectedDate).startOf('year');
        this.dateTo = moment(this._selectedDate).endOf('year');
        break;
      default:
    }

    this.setDateText();
    this.changeDate.emit({
      FromDate: this.dateFrom,
      ToDate: this.dateTo
    });
    calendarDropdown.instance.close();
  }

  setDateText() {
    if (this._selectedDate > this.maxDate) { this._selectedDate = this.maxDate; }

    var nb = moment(this._selectedDate).locale('nb');//norwegian text
    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this.text = nb.format('dddd DD.MM.YYYY');;
        break;
      case 1:
        let weeknumber = moment(this._selectedDate).isoWeek();
        let weekyear = moment(this._selectedDate).isoWeekYear();
        this.text = weeknumber + "." + weekyear;
        break;
      case 2:
        let month = nb.format('MMMM');
        let monthyear = moment(this._selectedDate).year();
        this.text = month + " " + monthyear;
        break;
      case 3:
        let year = moment(this._selectedDate).year();
        this.text = year.toString();
        break;
      default:
    }
  }

  setTabsDateRangeSelectedIndex() {
    switch (this.tabsDateRangeSelectedIndex)
    {
      case 0:
        this.minZoomLevel = "decade";
        this.maxZoomLevel = "month";
        this.zoomLevel = "month";
        break;
      case 1:
      this.minZoomLevel = "decade";
      this.maxZoomLevel = "month";
      this.zoomLevel = "month";
        break;
      case 2:
      this.minZoomLevel = "decade";
      this.maxZoomLevel = "year";
      this.zoomLevel = "year";
        break;
      case 3:
      this.minZoomLevel = "decade";
      this.maxZoomLevel = "decade";
      this.zoomLevel = "decade";
        break;
      default:
    }
    this.setDateText();
  }


  @Input()
  set selectedDate(date) {
    this._selectedDate = date;
    this.setDateText();
  }

  // Disable date selector when data is loading
  @Input()
  set setDisableSelector(disable: boolean) {
    this.disableSelector = disable;
  }
}

export class DateSelectorDateSettingPeriod {
  FromDate: moment.Moment = null;
  ToDate: moment.Moment = null;

  constructor() {
    const now = moment();
    this.FromDate = this.ToDate = now;
  }
}

export class DateSelectorDateSettings {
  selectedDateRangeIndex: number = null;
  selectedPeriod: DateSelectorDateSettingPeriod = null;

  constructor() {
    this.selectedPeriod = new DateSelectorDateSettingPeriod();
    this.selectedDateRangeIndex = 0;
  }
}
